import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'eBiletZezw/';

export default {

    getEprzystanki() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getEprzystankiPoTrasie(idTr) {
        return axios({
            method: 'get',
            url: URL+'trasa/'+idTr,
        });
    },

    addEprzystanek(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/ePrzystanki/EPrzystankiService.js